module.exports = __webpack_public_path__ + "static/media/3.0cb720e2.svg";